import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const carouselImages = [
  {
    url: 'https://images.unsplash.com/photo-1752884991461-8ac432ad9266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxGb3JtdWxhJTIwMSUyMHJhY2UlMjBjYXJzJTIwTW9uYWNvJTIwY2lyY3VpdHxlbnwwfHx8fDE3Njk1NTI2OTh8MA&ixlib=rb-4.1.0&q=85',
    title: { fr: 'Grand Prix de Monaco', en: 'Monaco Grand Prix', es: 'Gran Premio de Mónaco', de: 'Großer Preis von Monaco', it: 'Gran Premio di Monaco', nl: 'Grand Prix van Monaco', ru: 'Гран-при Монако', ar: 'جائزة موناكو الكبرى', zh: '摩纳哥大奖赛', ja: 'モナコグランプリ', ko: '모나코 그랑프리', hi: 'मोनाको ग्रैंड प्रिक्स' },
    subtitle: { fr: 'Course de Formule 1', en: 'Formula 1 race', es: 'Carrera de Fórmula 1', de: 'Formel-1-Rennen', it: 'Gara di Formula 1', nl: 'Formule 1 race', ru: 'Гонка Формулы-1', ar: 'سباق الفورمولا 1', zh: 'F1比赛', ja: 'F1レース', ko: 'F1 레이스', hi: 'फॉर्मूला 1 रेस' }
  },
  {
    url: 'https://i.ibb.co/JWDTybXt/Eze-village.webp',
    title: { fr: 'Village d\'Eze', en: 'Eze Village', es: 'Pueblo de Eze', de: 'Dorf Eze', it: 'Villaggio di Eze', nl: 'Dorp Eze', ru: 'Деревня Эз', ar: 'قرية إيز', zh: '埃兹村', ja: 'エズ村', ko: '에즈 마을', hi: 'एज़ गांव' },
    subtitle: { fr: 'Village médiéval perché', en: 'Perched medieval village', es: 'Pueblo medieval encaramado', de: 'Mittelalterliches Dorf', it: 'Borgo medievale arroccato', nl: 'Middeleeuws bergdorp', ru: 'Средневековая деревня', ar: 'قرية من القرون الوسطى', zh: '中世纪山村', ja: '中世の村', ko: '중세 마을', hi: 'मध्यकालीन गांव' }
  },
  {
    url: 'https://i.ibb.co/mCHf2KPR/jardin-exotique-d-Eze.webp',
    title: { fr: 'Jardin Exotique d\'Eze', en: 'Eze Exotic Garden', es: 'Jardín Exótico de Eze', de: 'Exotischer Garten Eze', it: 'Giardino Esotico di Eze', nl: 'Exotische Tuin Eze', ru: 'Экзотический сад Эз', ar: 'حديقة إيز الغريبة', zh: '埃兹异国花园', ja: 'エズのエキゾチックガーデン', ko: '에즈 이국적 정원', hi: 'एज़ विदेशी उद्यान' },
    subtitle: { fr: 'Vue panoramique', en: 'Panoramic view', es: 'Vista panorámica', de: 'Panoramablick', it: 'Vista panoramica', nl: 'Panoramisch uitzicht', ru: 'Панорамный вид', ar: 'منظر بانورامي', zh: '全景', ja: 'パノラマビュー', ko: '파노라마 뷰', hi: 'पैनोरमिक व्यू' }
  },
  {
    url: 'https://i.ibb.co/TMLNChjX/Plage-de-Eze-sur-mer.webp',
    title: { fr: 'Plage d\'Eze-sur-Mer', en: 'Eze-sur-Mer Beach', es: 'Playa de Eze-sur-Mer', de: 'Strand Eze-sur-Mer', it: 'Spiaggia di Eze-sur-Mer', nl: 'Strand Eze-sur-Mer', ru: 'Пляж Эз-сюр-Мер', ar: 'شاطئ إيز سور مير', zh: '滨海埃兹海滩', ja: 'エズ・シュル・メールビーチ', ko: '에즈 쉬르 메르 해변', hi: 'एज़ सुर मेर बीच' },
    subtitle: { fr: 'Eaux cristallines', en: 'Crystal clear waters', es: 'Aguas cristalinas', de: 'Kristallklares Wasser', it: 'Acque cristalline', nl: 'Kristalhelder water', ru: 'Кристально чистая вода', ar: 'مياه صافية', zh: '清澈的海水', ja: '透き通った海', ko: '맑은 바닷물', hi: 'क्रिस्टल साफ पानी' }
  },
  {
    url: 'https://i.ibb.co/W42TKt4W/port-de-Monaco.jpg',
    title: { fr: 'Port de Monaco', en: 'Monaco Port', es: 'Puerto de Mónaco', de: 'Hafen von Monaco', it: 'Porto di Monaco', nl: 'Haven van Monaco', ru: 'Порт Монако', ar: 'ميناء موناكو', zh: '摩纳哥港', ja: 'モナコ港', ko: '모나코 항구', hi: 'मोनाको बंदरगाह' },
    subtitle: { fr: 'À 10 minutes', en: '10 minutes away', es: 'A 10 minutos', de: '10 Minuten entfernt', it: 'A 10 minuti', nl: '10 minuten afstand', ru: 'В 10 минутах', ar: 'على بعد 10 دقائق', zh: '10分钟路程', ja: '10分の距離', ko: '10분 거리', hi: '10 मिनट दूर' }
  },
  {
    url: 'https://i.ibb.co/b5KpH3YT/Palais-de-Monaco.webp',
    title: { fr: 'Palais de Monaco', en: 'Monaco Palace', es: 'Palacio de Mónaco', de: 'Palast von Monaco', it: 'Palazzo di Monaco', nl: 'Paleis van Monaco', ru: 'Дворец Монако', ar: 'قصر موناكو', zh: '摩纳哥宫殿', ja: 'モナコ宮殿', ko: '모나코 궁전', hi: 'मोनाको महल' },
    subtitle: { fr: 'Résidence princière', en: 'Princely residence', es: 'Residencia principesca', de: 'Fürstliche Residenz', it: 'Residenza principesca', nl: 'Prinselijk paleis', ru: 'Княжеская резиденция', ar: 'الإقامة الأميرية', zh: '亲王宫殿', ja: '大公宮殿', ko: '대공 궁전', hi: 'राजकुमार निवास' }
  },
  {
    url: 'https://i.ibb.co/Hf8VyPz7/Plage-de-La-Mala-Cap-d-Ail.webp',
    title: { fr: 'Plage de La Mala', en: 'La Mala Beach', es: 'Playa La Mala', de: 'La Mala Strand', it: 'Spiaggia La Mala', nl: 'La Mala Strand', ru: 'Пляж Ла-Мала', ar: 'شاطئ لا مالا', zh: '拉马拉海滩', ja: 'ラ・マラビーチ', ko: '라 말라 해변', hi: 'ला माला बीच' },
    subtitle: { fr: 'Cap d\'Ail', en: 'Cap d\'Ail', es: 'Cap d\'Ail', de: 'Cap d\'Ail', it: 'Cap d\'Ail', nl: 'Cap d\'Ail', ru: 'Кап д\'Ай', ar: 'كاب دايل', zh: '艾尔角', ja: 'カップ・ダイユ', ko: '캡 다이유', hi: 'कैप डेल' }
  },
  {
    url: 'https://i.ibb.co/pv1qbYhZ/Plage-de-la-Paloma.webp',
    title: { fr: 'Plage de la Paloma', en: 'Paloma Beach', es: 'Playa Paloma', de: 'Paloma Strand', it: 'Spiaggia Paloma', nl: 'Paloma Strand', ru: 'Пляж Палома', ar: 'شاطئ بالوما', zh: '帕洛玛海滩', ja: 'パロマビーチ', ko: '팔로마 해변', hi: 'पालोमा बीच' },
    subtitle: { fr: 'Saint-Jean-Cap-Ferrat', en: 'Saint-Jean-Cap-Ferrat', es: 'Saint-Jean-Cap-Ferrat', de: 'Saint-Jean-Cap-Ferrat', it: 'Saint-Jean-Cap-Ferrat', nl: 'Saint-Jean-Cap-Ferrat', ru: 'Сен-Жан-Кап-Ферра', ar: 'سان جان كاب فيرا', zh: '圣让卡普费拉', ja: 'サン・ジャン・カップ・フェラ', ko: '생장 캡 페라', hi: 'सेंट जीन कैप फेरा' }
  },
  {
    url: 'https://i.ibb.co/JWVBQJgc/Baie-de-Villefranche.webp',
    title: { fr: 'Baie de Villefranche', en: 'Villefranche Bay', es: 'Bahía de Villefranche', de: 'Bucht von Villefranche', it: 'Baia di Villefranche', nl: 'Baai van Villefranche', ru: 'Залив Вильфранш', ar: 'خليج فيلفرانش', zh: '自由城湾', ja: 'ヴィルフランシュ湾', ko: '빌프랑슈 만', hi: 'विलेफ्रांश खाड़ी' },
    subtitle: { fr: 'Eaux turquoise', en: 'Turquoise waters', es: 'Aguas turquesas', de: 'Türkisfarbenes Wasser', it: 'Acque turchesi', nl: 'Turquoise water', ru: 'Бирюзовые воды', ar: 'مياه فيروزية', zh: '绿松石水域', ja: 'ターコイズブルーの海', ko: '청록색 바다', hi: 'फ़िरोज़ा पानी' }
  },
  {
    url: 'https://i.ibb.co/YF8nwqrC/vieux-port-de-Villefranche.webp',
    title: { fr: 'Vieux Port de Villefranche', en: 'Villefranche Old Port', es: 'Puerto Viejo de Villefranche', de: 'Alter Hafen Villefranche', it: 'Porto Vecchio di Villefranche', nl: 'Oude Haven Villefranche', ru: 'Старый порт Вильфранш', ar: 'الميناء القديم فيلفرانش', zh: '自由城老港', ja: 'ヴィルフランシュ旧港', ko: '빌프랑슈 구항', hi: 'विलेफ्रांश पुराना बंदरगाह' },
    subtitle: { fr: 'Charme provençal', en: 'Provençal charm', es: 'Encanto provenzal', de: 'Provenzalischer Charme', it: 'Fascino provenzale', nl: 'Provençaalse charme', ru: 'Провансальский шарм', ar: 'سحر بروفنسال', zh: '普罗旺斯魅力', ja: 'プロヴァンスの魅力', ko: '프로방스의 매력', hi: 'प्रोवेंसल आकर्षण' }
  },
  {
    url: 'https://i.ibb.co/0p0TpkSx/Baie-des-anges-Nice.webp',
    title: { fr: 'Baie des Anges', en: 'Bay of Angels', es: 'Bahía de los Ángeles', de: 'Engelsbucht', it: 'Baia degli Angeli', nl: 'Engelenbaai', ru: 'Залив Ангелов', ar: 'خليج الملائكة', zh: '天使湾', ja: '天使の湾', ko: '천사의 만', hi: 'एंजल्स की खाड़ी' },
    subtitle: { fr: 'Nice - À 15 minutes', en: 'Nice - 15 minutes away', es: 'Niza - A 15 minutos', de: 'Nizza - 15 Minuten entfernt', it: 'Nizza - A 15 minuti', nl: 'Nice - 15 minuten afstand', ru: 'Ницца - 15 минут', ar: 'نيس - 15 دقيقة', zh: '尼斯 - 15分钟', ja: 'ニース - 15分', ko: '니스 - 15분', hi: 'नीस - 15 मिनट' }
  },
  {
    url: 'https://i.ibb.co/YgNptBX/March-aux-fleurs-Nice-Cour-Saleya.webp',
    title: { fr: 'Marché aux Fleurs', en: 'Flower Market', es: 'Mercado de Flores', de: 'Blumenmarkt', it: 'Mercato dei Fiori', nl: 'Bloemenmarkt', ru: 'Цветочный рынок', ar: 'سوق الزهور', zh: '花卉市场', ja: '花市場', ko: '꽃 시장', hi: 'फूल बाजार' },
    subtitle: { fr: 'Cours Saleya - Nice', en: 'Cours Saleya - Nice', es: 'Cours Saleya - Niza', de: 'Cours Saleya - Nizza', it: 'Cours Saleya - Nizza', nl: 'Cours Saleya - Nice', ru: 'Кур Салея - Ницца', ar: 'كور ساليا - نيس', zh: '萨雷亚广场 - 尼斯', ja: 'クール・サレヤ - ニース', ko: '쿠르 살레야 - 니스', hi: 'कोर्स सालेया - नीस' }
  },
  {
    url: 'https://i.ibb.co/9Hxt4520/Menton.webp',
    title: { fr: 'Menton', en: 'Menton', es: 'Menton', de: 'Menton', it: 'Mentone', nl: 'Menton', ru: 'Ментон', ar: 'منتون', zh: '芒通', ja: 'マントン', ko: '망통', hi: 'मेंटन' },
    subtitle: { fr: 'Perle de la France', en: 'Pearl of France', es: 'Perla de Francia', de: 'Perle Frankreichs', it: 'Perla della Francia', nl: 'Parel van Frankrijk', ru: 'Жемчужина Франции', ar: 'لؤلؤة فرنسا', zh: '法国明珠', ja: 'フランスの真珠', ko: '프랑스의 진주', hi: 'फ्रांस का मोती' }
  },
  {
    url: 'https://i.ibb.co/XfdvnVpj/March-de-vingtimille.webp',
    title: { fr: 'Marché de Vintimille', en: 'Ventimiglia Market', es: 'Mercado de Ventimiglia', de: 'Markt Ventimiglia', it: 'Mercato di Ventimiglia', nl: 'Markt Ventimiglia', ru: 'Рынок Вентимильи', ar: 'سوق فينتيميليا', zh: '文蒂米利亚市场', ja: 'ヴェンティミーリア市場', ko: '벤티밀리아 시장', hi: 'वेंटिमिग्लिया बाजार' },
    subtitle: { fr: 'Italie - À 20 minutes', en: 'Italy - 20 minutes away', es: 'Italia - A 20 minutos', de: 'Italien - 20 Minuten entfernt', it: 'Italia - A 20 minuti', nl: 'Italië - 20 minuten afstand', ru: 'Италия - 20 минут', ar: 'إيطاليا - 20 دقيقة', zh: '意大利 - 20分钟', ja: 'イタリア - 20分', ko: '이탈리아 - 20분', hi: 'इटली - 20 मिनट' }
  },
  {
    url: 'https://i.ibb.co/zTQ6rpFn/Troph-e-d-Auguste-la-Turbie.webp',
    title: { fr: 'Trophée d\'Auguste', en: 'Trophy of Augustus', es: 'Trofeo de Augusto', de: 'Trophäe des Augustus', it: 'Trofeo di Augusto', nl: 'Trofee van Augustus', ru: 'Трофей Августа', ar: 'كأس أغسطس', zh: '奥古斯都纪念碑', ja: 'アウグストゥスのトロフィー', ko: '아우구스투스 기념비', hi: 'ऑगस्टस की ट्रॉफी' },
    subtitle: { fr: 'La Turbie - Monument romain', en: 'La Turbie - Roman monument', es: 'La Turbie - Monumento romano', de: 'La Turbie - Römisches Denkmal', it: 'La Turbie - Monumento romano', nl: 'La Turbie - Romeins monument', ru: 'Ла-Тюрби - Римский памятник', ar: 'لا توربي - نصب روماني', zh: '拉图尔比 - 罗马纪念碑', ja: 'ラ・テュルビ - ローマ記念碑', ko: '라 튀르비 - 로마 기념물', hi: 'ला तुर्बी - रोमन स्मारक' }
  }
];

export function DestinationsCarousel({ language = 'fr' }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  const currentImage = carouselImages[currentIndex];
  const title = currentImage.title[language] || currentImage.title['en'];
  const subtitle = currentImage.subtitle[language] || currentImage.subtitle['en'];

  return (
    <div 
      className="relative w-full h-[400px] md:h-[500px] overflow-hidden rounded-2xl group"
      onMouseEnter={() => setIsAutoPlaying(false)}
      onMouseLeave={() => setIsAutoPlaying(true)}
      data-testid="destinations-carousel"
    >
      {/* Images */}
      <div 
        className="flex transition-transform duration-700 ease-out h-full"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {carouselImages.map((image, index) => (
          <div key={index} className="min-w-full h-full relative">
            <img
              src={image.url}
              alt={image.title[language] || image.title['en']}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          </div>
        ))}
      </div>

      {/* Title and subtitle */}
      <div className="absolute bottom-16 left-0 right-0 text-center text-white px-4">
        <h3 className="text-3xl md:text-4xl font-bold mb-2 drop-shadow-lg">{title}</h3>
        <p className="text-lg md:text-xl text-white/90 drop-shadow-md">{subtitle}</p>
      </div>

      {/* Navigation arrows */}
      <button
        onClick={goToPrevious}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white p-2 rounded-full transition-all opacity-0 group-hover:opacity-100"
        aria-label="Previous"
      >
        <ChevronLeft size={24} />
      </button>
      <button
        onClick={goToNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white p-2 rounded-full transition-all opacity-0 group-hover:opacity-100"
        aria-label="Next"
      >
        <ChevronRight size={24} />
      </button>

      {/* Dots indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {carouselImages.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentIndex 
                ? 'bg-white w-6' 
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
